"use client";

import { useState, useEffect } from "react";

import type { FancyboxOptions } from "@fancyapps/ui/dist/fancybox/";

export default function useFancybox(options: Partial<FancyboxOptions> = {}) {
	const [root, setRoot] = useState<HTMLElement | null>(null);

	useEffect(() => {
		if (!root) return;

		let unbind: (() => void) | undefined;
		let cancelled = false;

		Promise.all([import("@fancyapps/ui/dist/fancybox/"), import("@fancyapps/ui/dist/fancybox/fancybox.css")]).then(([{ Fancybox }]) => {
			if (cancelled) return;
			Fancybox.bind(root, "[data-fancybox]", options);
			unbind = () => Fancybox.unbind(root);
		});

		return () => {
			cancelled = true;
			unbind?.();
		};
	}, [root, options]);

	return [setRoot];
}
